import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-Templates', [
  'table',
  'count',
  'familyRow',
  'variantRow',
  'standaloneRow',
  'templateLink',
  'heading',
  'variablesTable',
  'defaultWording',
  'wordingNotSetUp',
  'storedCopyNotInUse',
  'storedCopyUnreadable',
  'editButton',
  'subjectInput',
  'previewTextInput',
  'bodyEditor',
  'variablePicker',
  'saveButton',
  'formatToolbar',
  'linkInput',
  'insertFragment',
  'insertCta',
  'removeBlock',
  'ctaLabelInput',
  'ctaTargetInput',
  'ctaConfirm',
]);
